import {
  arrayOf as arrayType,
  number as numberType,
  params,
  shape as shapeType,
  string as stringType
} from '@thd-nucleus/data-sources';

export const dataModel = {
  product: params({ itemId: stringType().isRequired() }).shape({
    itemId: stringType(),
    dataSources: stringType(),
    identifiers: shapeType({
      canonicalUrl: stringType(),
      productLabel: stringType()
    })
  }),
  questionsAnswers: params({
    itemId: stringType().isRequired(),
    startindex: numberType(),
    pagesize: numberType()
  }).shape({
    Includes: shapeType({
      Answers: arrayType(shapeType({
        AnswerId: stringType(),
        Answer: {
          Id: stringType(),
          AnswerText: stringType()
        }
      })),
      AnswersOrder: arrayType(stringType())
    }),
    Limit: numberType(),
    Offset: numberType(),
    Results: arrayType(shapeType({
      AnswerIds: arrayType(stringType()),
      QuestionSummary: stringType(),
      SubmissionTime: stringType(),
      UserNickname: stringType()
    })),
    TotalResults: numberType()
  })
};
